import styled from 'styled-components';

export const ColoredRound = styled.div`
  flex: 1;
  height: 36px;
  border-radius: 8px;
  background-color: ${({ color }) => color};
`;
